import SectionHeader from './SectionHeader';

function vaccInfo(dateStr) {
  if (!dateStr) return { overdue: false, daysLeft: null };
  try {
    const [d, m, y] = dateStr.split('.').map(Number);
    const vaccDate = new Date(2000 + y, m - 1, d);
    const now = new Date();
    const diffMs = now - vaccDate;
    const diffMonths = diffMs / (1000 * 60 * 60 * 24 * 30.44);
    if (diffMonths < 10) return { overdue: false, daysLeft: null };
    const anniversary = new Date(vaccDate);
    anniversary.setFullYear(anniversary.getFullYear() + 1);
    const msLeft = anniversary - now;
    const daysLeft = Math.ceil(msLeft / (1000 * 60 * 60 * 24));
    return { overdue: true, daysLeft: daysLeft > 0 ? daysLeft : 0 };
  } catch {
    return { overdue: false, daysLeft: null };
  }
}

function VaccBlock({ title, data }) {
  const { overdue, daysLeft } = vaccInfo(data.date);
  if (!data.date) return (
    <div className="vacc-block vacc-empty">
      <span className="vacc-title">{title}</span>
      <span className="vacc-none">Не указано</span>
    </div>
  );
  return (
    <div className={`vacc-block${overdue ? ' vacc-overdue' : ''}`}>
      <span className="vacc-title">{title}</span>
      <span className="vacc-date">📅 {data.date}</span>
      {data.medication && <span className="vacc-med">💊 {data.medication}</span>}
      {overdue && daysLeft !== null && (
        <span className="vacc-days-left">
          {daysLeft === 0 ? 'Срок истёк!' : `До года осталось ${daysLeft} дн.`}
        </span>
      )}
    </div>
  );
}

function OtherVaccBlock({ vacc }) {
  const { overdue, daysLeft } = vaccInfo(vacc.date);
  return (
    <div className={`vacc-block${overdue ? ' vacc-overdue' : ''}`}>
      <span className="vacc-title">💉 {vacc.name}</span>
      {vacc.date
        ? <span className="vacc-date">📅 {vacc.date}</span>
        : <span className="vacc-none">Дата не указана</span>
      }
      {vacc.medication && <span className="vacc-med">💊 {vacc.medication}</span>}
      {overdue && daysLeft !== null && (
        <span className="vacc-days-left">
          {daysLeft === 0 ? 'Срок истёк!' : `До года осталось ${daysLeft} дн.`}
        </span>
      )}
    </div>
  );
}

export default function RecentTreatmentsBlock({ pet, petId, standalone = false, docProps }) {
  const content = (
    <>
      <VaccBlock title="🦠 Против бешенства" data={pet.last_rabies} />
      <VaccBlock title="🪱 Дегельминтизация" data={pet.last_deworming} />
      <VaccBlock title="🦟 Против эктопаразитов" data={pet.last_ectoparasites} />
      {pet.other_vaccinations?.map((v) => (
        <OtherVaccBlock key={v.name} vacc={v} />
      ))}
    </>
  );

  if (standalone) {
    return (
      <div className="ps-block">
        <div className="ps-block-title">💉 Последние обработки</div>
        {content}
      </div>
    );
  }

  return (
    <section className="card-section" id="section-vacc">
      <SectionHeader
        title="Последние обработки"
        pdfPath={`/api/pets/${petId}/vaccinations/pdf`}
        pdfName={`${pet.name}_обработки.pdf`}
        periodMode="years"
        sectionKey="vacc"
        {...docProps}
      />
      {content}
    </section>
  );
}
